import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2fab46ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = { class: "login-form-container" }
const _hoisted_4 = { class: "auth-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Подтверждение регистрации", -1))
const _hoisted_6 = {
  key: 0,
  class: "text"
}
const _hoisted_7 = {
  key: 1,
  class: "bad-msg"
}
const _hoisted_8 = {
  key: 2,
  class: "actions"
}
const _hoisted_9 = {
  key: 3,
  class: "fl-senter m-t-5"
}

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { rootGetters } from "@/main";

import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";

import DvLogoComponent from "@/shared/auth/DvLogoComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterConfirmPage',
  setup(__props) {

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();
const status = ref<"loading" | "error">("loading");
const errorMessage = ref("");

const confirmRegistration = async () => {
  const nonce = route.query.nonce?.toString();
  if (!nonce) {
    status.value = "error";
    errorMessage.value = "Некорректная ссылка подтверждения.";
    return;
  }

  await authStore
    .registerConfirm(nonce)
    .then(async () => {
      await authStore.getUserInfo();
      await router.push({ path: "/" });
    })
    .catch((err) => {
      status.value = "error";
      if (err.response && err.response.status === 400) {
        errorMessage.value = "Ссылка устарела или уже использована.";
      } else {
        rootGetters.toast.show(
          "error",
          "Произошла ошибка",
          "Обратитесь к администратору или проверьте соединение с интернетом."
        );
        errorMessage.value = "Не удалось подтвердить регистрацию.";
      }
    });
};

onMounted(() => {
  confirmRegistration();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DvLogoComponent)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (status.value === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Подтверждаем вашу регистрацию... "))
          : _createCommentVNode("", true),
        (status.value === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (status.value === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(Button), {
                label: "Перейти к регистрации",
                class: "form-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'signup' })))
              })
            ]))
          : _createCommentVNode("", true),
        (status.value === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(ProgressSpinner), {
                "aria-label": "Loading",
                style: {"width":"30px","height":"30px"},
                strokeWidth: "2",
                fill: "var(--surface-ground)"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})